import { useEffect, useState } from 'react';
import { api } from '../../services/api';
import { CaptchaProvider } from './captcha-types';

/**
 * Провайдер капчи, выбранный бэкендом (по гео). `undefined` — конфиг ещё в
 * полёте: капчу в этот момент не рендерим и её скрипты не грузим. Ошибка
 * запроса — фолбэк на 'yandex'.
 */
export function useCaptchaProvider(): CaptchaProvider | undefined {
  const [provider, setProvider] = useState<CaptchaProvider | undefined>(
    undefined,
  );
  useEffect(() => {
    let alive = true;
    api
      .get('/public/captcha-config')
      .then((res) => {
        if (!alive) return;
        setProvider(res.data?.provider === 'tencent' ? 'tencent' : 'yandex');
      })
      .catch(() => {
        // эндпоинта может не быть на стенде — фолбэк как раньше
        if (alive) setProvider('yandex');
      });
    return () => {
      alive = false;
    };
  }, []);
  return provider;
}
